import { LectureId } from '../../courses/curriculum/types/lecture-interface'
import {
  GetCourseCurriculumUrlProps,
  getCourseCurriculumUrl,
} from '../../courses/utils/get-course-curriculum-url'

export const getCourseLectureAssignmentUrl = ({
  lectureId,
  hasAssignmentSettings,
  ...restArgs
}: GetCourseCurriculumUrlProps & { lectureId: LectureId; hasAssignmentSettings: boolean }) =>
  `${getCourseCurriculumUrl(restArgs)}/${lectureId}/assignment/${
    hasAssignmentSettings ? 'edit' : 'create'
  }`
